@if (atgardListToCopyTo?.length) {
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">Kopiera geometri ifrån åtgärd</h3>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <rask-skogsvard-select-atgard
        [listOfAtgarder]="copyFromAtgardList"
        [selectedAtgardGuid]="preSelectedAtgard"
        [isAtgardRequired]="false"
        (selected)="copyFromAtgardChanged($event)">
    </rask-skogsvard-select-atgard>

    <div class="row mt-5">
      <div class="col-12 list-wrapper">
        <rask-list [data]="atgardListToCopyTo" [fixedHeader]="true" key="atgardGuid">
          <rask-list-column width="100px" header="Kopiera till" rowSelectable="true">
            <ng-template let-row="row">
                <div style="line-height: 64px">
                    <rask-checkbox [ngModel]="row.checked" (ngModelChange)="row.checked = $event" [disabled]="row.isSourceAtgard || row.isReadonly"></rask-checkbox>
                </div>
            </ng-template>
          </rask-list-column>

          <rask-list-column header="DNR">
            <ng-template let-row="row">
              <span class="vk-text mx-1">{{ row.beteckning }}</span>
            </ng-template>
          </rask-list-column>

          <rask-list-column header="Åtgärdstyp">
            <ng-template let-row="row">
              <span class="vk-text mx-1">{{ row.atgardstyp }}</span>
            </ng-template>
          </rask-list-column>

          <rask-list-column header="Planeringsstatus">
            <ng-template let-row="row">
              <span class="vk-text mx-1">{{ row.status }}</span>
            </ng-template>
          </rask-list-column>
        </rask-list>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <rask-button aid="buttonSpara" color="primary" (click)="copy()" [disabled]="!canCopy()">Kopiera geometrier</rask-button>
    <rask-button aid="buttonAvbryt" color="secondary" (click)="close()" ngbAutofocus>Avbryt</rask-button>
  </div>
}